import { Decimal } from "decimal.js";

export default {
 methods: {
  numberFormatter(number) {
   //adds commas to all numbers
   if (number.value != undefined) {
    return parseFloat(number.value)
     .toFixed(2)
     .toString()
     .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
   }
   return " ";
  },
  numberFormatterFloat(number) {
   //adds commas to all numbers
   if (number != undefined) {
    return parseFloat(number)
     .toFixed(2)
     .toString()
     .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
   }
   return " ";
  },
  numberFormatterString(number) {
    //adds commas to all numbers
    if (number != undefined) {
     return parseFloat(number)
      .toString()
      .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    }
    return " ";
   },
  roundNumTo2Decimals(value) {
   const numFormat = new Intl.NumberFormat("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
   });
   return numFormat.format(value);
  },
  roundNumToNDecimals(value, rounding) {
   const numFormat = new Intl.NumberFormat("en-US", {
    minimumFractionDigits: rounding,
    maximumFractionDigits: rounding,
   });
   if (rounding > 2) {
    return Number(parseFloat(numFormat.format(value)).toFixed(rounding));
   }
   return numFormat.format(value);
  },
  decimalCount(value) {
   const decimalIndex = value.toString().indexOf(".");
   return decimalIndex >= 0 ? value.toString().length - decimalIndex - 1 : 0;
  },
  roundWithFunc(num, digits, func) {
    if (typeof num !== "number") {
      return num;
    }
    if (!func) {
      func = Math.round;
    }
    let val = func(num * Math.pow(10, digits))
    return (val / Math.pow(10, digits)).toFixed(digits);
  }
 },
 data() {
  return {};
 },
};
